import settings from 'settings'
import { postRequest } from 'features/common'

const { workspaceApiUrl } = settings

export type PostHelpQuestionResponse = {
  markdownText: string
  sources: string[]
} | null
// Question has no answer

function requestCallback(response: Response): Promise<PostHelpQuestionResponse> | null {
  if (response.status === 204) {
    return null
  } else if (response.ok) {
    return response.json()
  } else {
    throw new Error(`Failed to post help question: ${response.status} ${response.statusText}`)
  }
}

export const postHelpQuestion = async (query: string) => {
  return postRequest<{ query: string }, PostHelpQuestionResponse>(
    `${workspaceApiUrl}/helpQuestion`,
    { query },
    undefined,
    requestCallback
  )
}
